var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-text"},[_c('p',{staticClass:"course-text"},[_vm._v("Mis Cursos")])])])
}]

export { render, staticRenderFns }